import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import map from 'lodash/map';
import RCPagination from '../../UserControl/Pagination/RCPagination';
import moment from 'moment';
import { getMonthTHFromInt } from '../../../../util/util';
import ModalConfirmDelete from '../../../Modals/ModalConfirmDelete';
import { checkStatus } from '../../../../util/util';
import {AlertConfirm, AlertCommit} from '../../../Modals/AlertBar';
import { withNamespaces } from 'react-i18next';
import { positions, Provider } from "react-alert";

class DeviceUserRelated extends Component {

    constructor() {
        super();
        this.state = {
            selectedDevice: '',
            userDeviceRelatedList: [],
            currentPage: 1,
            currentPageSize: 10,
            totalPage: 0,
            deviceNoList: [],
            search: '',
            deviceId: '',
            ShowDeleteRow: false,
            dataSelectRow: null
        }
    }

    componentWillMount() {
        console.log('componentWillMount:::::')
    }

    componentDidMount() {
        this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize);
        this.getDeviceUserRelated();
    }

    componentWillUnmount(){
        this.setState({selectedDevice: ''});
    }


    getDeviceUserRelated() {
        const {
            user_id,
            user_name,
            token,
            user_ids
        } = this.props;
        fetch(`http://203.150.199.244/api/admin/getDeviceNoUserRelated/${user_ids}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({})
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                this.setState({
                    deviceNoList: data.RESULT_DATA
                })
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    onPageSizeChange(page, pageSize){
        const { user_id, user_ids, user_name,token} = this.props;
        const { search } = this.state;
        fetch(`http://203.150.199.244/api/admin/getDeviceUserRelated/${user_ids}/${page}/${pageSize}` , {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                "filter": search
            })
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                // console.log('getDeviceUserRelated:', data);
                if (data) {
                    console.log('getDeviceUserRelated:', data);
                    this.setState({
                        userDeviceRelatedList: data.RESULT_DATA,
                        currentPage: page,
                        totalPage: data.RESULT_TOTAL,
                        currentPageSize: pageSize
                    })
                }
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

    }

    onPageSelect(page){
        const { currentPageSize, search } = this.state;
        const {
            user_id,
            user_ids,
            user_name,
            token
        } = this.props;
        fetch(`http://203.150.199.244/api/admin/getDeviceUserRelated/${user_ids}/${page}/${currentPageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                "filter":search
            })
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                this.setState({
                    userDeviceRelatedList:data.RESULT_DATA,
                    // deviceList:data.RESULT_DATA,
                    currentPage:page,
                    totalPage:data.RESULT_TOTAL,
                    currentPageSize:currentPageSize
                })
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    handleChange = (selectedDevice) => {
        this.setState({ selectedDevice });
    }

    handleOnAddDeviceRelate = () => {
        const { selectedDevice } = this.state;
        console.log('handleOnAddDeviceRelate::::');
        const {
            user_name,
            user_id,
            user_ids,
            token
        } = this.props;
        fetch(`http://203.150.199.244/api/admin/assignDevice/${user_ids}/${selectedDevice.value}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({})
        })

            .then(response => { return checkStatus(response)})
            .then(() => this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize), this.setState({selectedDevice: ''}))
            .then(this.getDeviceUserRelated())
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

    }

    editeDevice(data) {
        this.setState({
            dataSelectRow: data,
            isShowEdit: true,
            isShowCreateNewDealer: true,
            notification: false
        })
    }

    onEditDeviceClose(){
        this.btnEditClose.click();
        // this.setState({
        //     isShowEdit:false
        // })
    }

    editDevice = (deviceId) => {
        const { history } = this.props;
        history.push({ pathname: '/admin_config', state: { sideBarName: 'deviceInformation', isFromDeviceUserRelated: true, deviceId: deviceId} });
    }

    deleteDevice(data){
        // console.log('deleteDevice:', data);
        this.setState({
            dataSelectRow: data,
            // isShowEdit: false,
            // isShowCreateNewDealer: false,
            // ShowDeleteRow: true
        })

        this.onClickConfirmDelete();
    }

    onClickCancelDelete = (status) => {
        this.setState({ ShowDeleteRow: status });
    }

    onClickConfirmDelete = () => {

        AlertConfirm("ลบ Device","คุณต้องการลบ Device หรือไม่").then(isOk=>{
            if(isOk){
        const {
            user_name,
            user_id,
            user_ids,
            token
        } = this.props;
        const { dataSelectRow } = this.state;
        fetch(`http://203.150.199.244/api/admin/cancelDevice/${user_ids}/${dataSelectRow.device_id}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({})
        })
            // .then(response => response.json())
            .then(response => { return checkStatus(response)})
            .then((data) => {

                if(data.RESULT_STATUS == "000")
                    AlertCommit(true,"ลบข้อมูลเรียบร้อยแล้ว");
                else{
                    AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                }
                this.setState({ ShowDeleteRow: false, notification: true })})

            .then(() => this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize))
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
        }
    });
    }


    convertDateFormat(date){
        let dateString = date.substring(0,10);
        let str = dateString.split("-");
        let year = parseInt(str[2])+543;
        let month = getMonthTHFromInt(parseInt(str[1]));
        return str[0]+' '+month.toString()+' '+year.toString();
    }

    render() {
        const {
            selectedDevice,
            deviceNoList,
            totalPage,
            currentPageSize,
            userDeviceRelatedList,
            ShowDeleteRow,
            currentPage
        } = this.state;
        const { t } = this.props;

        let dataLoop;
        const dataList = map(deviceNoList, (dataEach) => {
            dataLoop = {
                value: dataEach.device_id,
                label: dataEach.device_no
            };

            return dataLoop;
        });
        console.log('userDeviceRelatedList:', userDeviceRelatedList);
        let rows = [];
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        userDeviceRelatedList.map((device, index)=>{
            rows.push(
                <tr key={device.serial}>
                    <td >{(currentPage - 1) * currentPageSize + (index+1)}</td>
                    <td >{device.device_id}</td>
                    <td >{device.device_no}</td>
                    <td>{device.imei}</td>
                    <td>{device.model}</td>
                    <td>{(device.install_date) ? (moment(device.install_date).locale('th').format('DD')) + '/' + (moment(device.install_date).locale('th').format('MM')) + '/' + (parseInt(moment(device.install_date).locale('th').format('YYYY')) + 543) : ''}</td>
                    <td>{(device.expire_date) ? (moment(device.expire_date).locale('th').format('DD')) + '/' + (moment(device.expire_date).locale('th').format('MM')) + '/' + (parseInt(moment(device.expire_date).locale('th').format('YYYY')) + 543) : ''}</td>
                    <td>{(device.last_upd_dtm) ? (moment(device.last_upd_dtm).locale('th').format('DD')) + '/' + (moment(device.last_upd_dtm).locale('th').format('MM')) + '/' + (parseInt(moment(device.last_upd_dtm).locale('th').format('YYYY')) + 543) + ' ' + moment(device.last_upd_dtm).locale('th').format('HH:mm') : ''}</td>
                    <td>
                        <button
                            onClick={this.editDevice.bind(this, device.device_id)}
                            className="btn btn btn-primary btn-xs"
                            data-title="Edit"
                            data-toggle="modal"
                            data-target="#editDevice"
                            data-backdrop="static"
                            data-keyboard="false">
                            <span className="fa fa-edit" />
                        </button>
                    </td>
                    <td>
                        <button
                            onClick={this.deleteDevice.bind(this, device)}
                            className="btn btn-danger btn-xs"
                            data-title="Delete"
                            data-toggle="modal"
                            data-target="#deleteDevice"
                            data-backdrop="static"
                            data-keyboard="false">
                            <span className="fa fa-trash" />
                        </button>
                    </td>
                </tr>
            )

        });

        return(
                <div>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title custom_align" id="Heading">บันทึกข้อมูลผู้ใช้งาน</h6>
                        </div>
                        <div className="modal-body">

                            <div className="form-group row">
                                <label className="col-md-2 col-form-label">เพิ่ม ชื่อเครื่อง</label>
                                <div className="col-md-5">
                                    <Select
                                        value={selectedDevice}
                                        onChange={this.handleChange}
                                        options={dataList}
                                    />
                                </div>
                                <div className="col-md-5">
                                    <button
                                        id="btn-device-add"
                                        type="button"
                                        onClick={this.handleOnAddDeviceRelate}
                                        className="btn btn-success ">
                                        <i className="fa fa-fw fa-plus" />
                                        เพิ่มรายการ
                                    </button>
                                </div>
                            </div>

                            <div className="col-md-12 table-responsive">
                                <table  className="table table-bordred table-striped table-hover ">
                                    <thead >
                                    <tr>
                                        <th>#</th>
                                        <th style={{minWidth:100}}>Serv</th>
                                        <th style={{minWidth:100}}>{t('ชื่อผู้ใช้งาน')}</th>
                                        <th style={{minWidth:100}}>อีมี่</th>
                                        <th style={{minWidth:100}}>รุ่น</th>
                                        <th style={{minWidth:100}}>วันที่ติดตั้ง</th>
                                        <th style={{minWidth:100}}>ครบกำหนด</th>
                                        <th style={{minWidth:100}}>อัพเดตล่าสุด</th>
                                        <th style={{minWidth: 20}}></th>
                                        <th style={{minWidth: 20}}></th>
                                    </tr></thead>
                                    <tbody>
                                    {rows}
                                    </tbody>
                                </table>

                            </div>
                            <RCPagination onSelect={this.onPageSelect.bind(this)} onShowSizeChange={this.onPageSizeChange.bind(this)} total={totalPage} pageSize={currentPageSize}/>

                        </div>
                  </div>
                    { ShowDeleteRow &&
                    <ModalConfirmDelete
                        onClickCancelDelete={this.onClickCancelDelete}
                        onClickConfirmDelete={this.onClickConfirmDelete}
                    />
                    }
                </div>
        );
    }
}

// DeviceUserRelated.defaultProps = {
//     dataSelectRow: {}
// }
//
DeviceUserRelated.propTypes = {
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    user_ids: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    history: PropTypes.func.isRequired
}


export default withNamespaces('Menubar')(DeviceUserRelated);



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/DeviceUserRelated.js